import styled, { css } from 'styled-components';
import { Colors } from '~/config/Colors';
// import Card from '~/pages/Sistema/componentes/Card';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  width: 100%;
  height: 100%;
  padding: 16px;
  margin-bottom: 24px;

  border-radius: 20px;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;

  border: 1px solid ${Colors.Border_Color_1};
  background-color: transparent;
  border-radius: 12px;
  padding: 16px;

  box-shadow: rgba(0, 0, 0, 0.3) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
`;

export const InputContent = styled.div`
  display: grid;
  grid-template-columns: 2fr repeat(4, 1fr) 36px;
  align-items: flex-end;
  gap: 16px;
  width: 100%;
`;

// export const Input = styled.input`
//   width: 100%;
//   height: 100%;
//   border: 1px solid ${Colors.bgCardColor};
//   background-color: transparent;
//   border-radius: 12px;

//   font-size: 16px;
//   color: ${Colors.Color4};
// `;

export const DateContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  input {
    cursor: pointer !important;
    background: transparent !important;
    border: 1px solid rgb(255 255 255 / 0.15) !important;
    border-radius: 8px !important;
    padding: 16px !important;
    color: #fff !important;
    font-size: 0.7em !important;
    font-weight: 300 !important;
    width: 100% !important;
    height: 36px !important;
    box-shadow: none !important;
  }

  ${props =>
    props.disabled &&
    css`
      input {
        cursor: not-allowed !important;
        pointer-events: none !important;
        opacity: 0.5 !important;
      }
    `}
`;

// export const Select = styled.select`
//   width: 100%;
//   background-color: transparent;
//   border: 1px solid ${Colors.bgCardColor};
//   border-radius: 12px;
//   color: ${Colors.Color30};
//   font-size: 16px;
//   padding: 8px;
//   /* appearance: none; */
// `;
// export const Option = styled.option`
//   background: #ffffff10;

//   color: #333;
// `;

export const TotalContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  gap: 16px;
`;

// export const Status = styled.ul`
//   font-size: 0.9em;
//   font-weight: 600;
//   color: ${Colors.Color14};

//   border: 0.1rem solid rgba(255, 255, 255, 0.1);
//   border-radius: 0.5rem;
//   padding: 0.6rem;
// `;

// export const ProposalStateList = styled.li`
//   display: flex;
//   justify-content: space-between;
//   gap: 0.4em;

//   border-bottom: 0.1rem solid rgba(255, 255, 255, 0.1);

//   span {
//     display: flex;
//     align-items: center;
//     justify-content: flex-end;

//     font-size: 0.8em;
//     font-weight: 500;
//     color: ${Colors.Color14};
//     min-width: 72px;

//     &:first-child {
//       justify-content: flex-start;
//       min-width: 120px;
//       font-weight: 400;

//       white-space: nowrap;
//       overflow: hidden;
//       text-overflow: ellipsis;

//       &:before {
//         content: '';
//         display: inline-block;

//         width: 0.5rem;
//         height: 0.5rem;
//         margin-right: 0.4rem;

//         border-radius: 0.1rem;
//         background-color: ${props => props.color};
//       }
//     }
//   }

//   &:last-child {
//     padding-bottom: 0;
//     border: none;
//   }
// `;

export const Table = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${Colors.bgCardColor};

  border-radius: 12px;
  text-align: center;

  border: 1px solid ${Colors.Border_Color_1};
  box-shadow: rgba(0, 0, 0, 0.3) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;

  .skeleton {
    background: ${localStorage.getItem('tema') == 'E'
      ? 'linear-gradient(90deg, #ffffff15 25%, #ffffff05 50%, #ffffff10 75%)'
      : 'linear-gradient(90deg, #6796cf50 25%, #6796cf25 50%, #6796cf50 75%)'};
    background-size: 200% 100%;
    animation: skeleton-loading 4s infinite linear;
    border-radius: 4px;
  }

  @keyframes skeleton-loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }
`;

export const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 1rem 2fr repeat(6, 1fr);
  width: 100%;
  padding: 24px;
  gap: 16px;
  background-color: #6796cf;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;

  font-size: 16px;
  color: ${Colors.Color30};
  font-weight: 500;
  line-height: 24px;
`;

export const TableBody = styled.div`
  display: grid;
  grid-template-columns: 1rem 2fr repeat(6, 1fr);
  align-items: center;
  width: 100%;
  padding: 24px;
  gap: 16px;

  font-size: 16px;
  color: ${Colors.text_Color_1};
  font-weight: 300;
  line-height: 24px;

  border-bottom: 1px solid
    ${props => (props.hasBorder ? `${Colors.Border_Color_1}` : 'transparent')};
  &:last-child {
    border-bottom: none;
  }

  .btn {
    display: flex;
    border: none;
    background-color: transparent;
  }

  .btn_circle {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;

    border: 1px solid transparent;
    background-color: transparent;
    border-radius: 4px;

    color: ${Colors.Color7};

    i {
      font-size: 24px;
      line-height: 1;
    }

    transition: background-color, border 0.3s;

    cursor: ${({ loading }) => (loading ? 'wait' : 'pointer')};

    &:hover {
      background-color: ${Colors.Border_Color_1};
      border: 1px solid ${Colors.Border_Color_1};
    }
  }
`;

export const TableBodySkeleton = styled.div`
  display: grid;
  grid-template-columns: 1rem 2fr repeat(6, 1fr);
  width: 100%;
  padding: 24px;
  gap: 16px;

  align-items: center;
  justify-items: center;

  border-bottom: 1px solid #ffffff25;

  &:last-child {
    border-bottom: none;
  }
`;

export const TableBodyNobody = styled.div`
  /* display: grid;
  grid-template-columns: 1rem 2fr repeat(6, 1fr); */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  height: 370px;
  width: 100%;
  padding: 24px;
  gap: 16px;

  font-size: 16px;
  color: ${Colors.Color30};
  font-weight: 300;
  line-height: 24px;
  text-align: center;

  &:last-child {
    border-bottom: none;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;
